/**
 * @generated SignedSource<<bd6dd8bda9f405a8f46f949c324316e3>>
 * @relayHash c317aa860705d21ca946b5a9e1032fbf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0b69c94620ba59354108e4f96ae534dce0b868e405dfaa04836aabd3b391322d

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StatuspageDetailsPageQuery$variables = {
  pageId: string;
};
export type StatuspageDetailsPageQuery$data = {
  readonly stakeholderComms_getPageById: {
    readonly error: string | null | undefined;
    readonly page: {
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"StatuspageDetails">;
    } | null | undefined;
  } | null | undefined;
};
export type StatuspageDetailsPageQuery = {
  response: StatuspageDetailsPageQuery$data;
  variables: StatuspageDetailsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pageId",
    "variableName": "pageId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "error"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StatuspageDetailsPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "StakeholderCommsPageResponse",
        "kind": "LinkedField",
        "name": "stakeholderComms_getPageById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "StakeholderCommsPage",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "StatuspageDetails"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StatuspageDetailsPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "StakeholderCommsPageResponse",
        "kind": "LinkedField",
        "name": "stakeholderComms_getPageById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "StakeholderCommsPage",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "subdomain"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0b69c94620ba59354108e4f96ae534dce0b868e405dfaa04836aabd3b391322d",
    "metadata": {},
    "name": "StatuspageDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "02ffc2af429e1859237b3c8a7de32a99";

export default node;
